import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

// ui
import DashboardContainer from '../../containers/Dashboard';
import AuthUserContainer from '../../containers/AuthUser';
import FMPSectionCard from '../../components/ui/FMPSectionCard';

// icons
import OcrIcon from '../../images/icons/ocr.svg';
import RobotIcon from '../../images/icons/robotColor.svg';

const styles = (theme) => {
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		panel: {
			marginTop: 30,
		},
		emptyPanel: {
			minHeight: 270,
			fontWeight: 100,
			color: '#aaa',
			fontSize: 30,
			marginTop: 30,
		},
		innerPaper: {
			padding: 10,
			paddingTop: 5,
			textAlign: 'left',
			fontSize: 14,
			[theme.breakpoints.up('md')]: {
				padding: 40,
				paddingTop: 30,
			},
		},
		lastFtpCheck: {
			//marginTop : 20,
			//color : "#888"
		},
		ftpSection: {
			lineHeight: 1.6,
			marginTop: 10,
		},
		title: {
			textTransform: 'uppercase',
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
			marginBottom: 5,
		},
		label: {},

		labelDate: {
			fontSize: 12,
			fontWeight: 100,
			color: '#999',
		},
		value: {
			fontWeight: 600,
		},
		statusIcon: {
			position: 'absolute',
			right: 0,
		},
		ftpWarning: {
			color: '#FFC107',
		},
		ftpGood: {
			color: '#4CAF50',
		},
		ftpStatusIcon: {
			width: 14,
			height: 14,
			verticalAlign: 'middle',
			paddingLeft: 5,
		},
		ftpStatusIconLarge: {
			width: 32,
			height: 32,
			verticalAlign: 'middle',
		},
		dataSection: {
			marginTop: 25,
			lineHeight: 1.6,
		},
		dgsButton: {
			position: 'relative',
			right: 0,
			borderRadius: 100,
		},
		dgsButtonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
			marginTop: 30,
		},
		tableRow: {
			fontWeight: 400,
		},
		row: {
			margin: 0,
			width: '100%',
			backgroundColor: '#fff',
		},
		oddRow: {
			margin: 0,
			width: '100%',
			backgroundColor: '#eee',
		},
		masthead: {
			textAlign: 'left',
			fontSize: 24,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 15,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,

			[theme.breakpoints.up('sm')]: {
				fontWeight: 300,
				fontSize: 22,
				//margin: '10px 0px 10px 0px',
			},
			[theme.breakpoints.up('md')]: {
				fontSize: 30,
				//margin: '10px 0px 10px 0px',
			},
		},
		subMasthead: {
			textAlign: 'left',
			fontSize: 18,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 10,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,
		},
	};
};

class ApAutomationDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { classes } = this.props;

		return (
			<>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.masthead}>AP Automation Dashboard</div>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'AP Ingestion'}
							icon={OcrIcon}
							description={`Upload carrier and fuel invoices and have the system 
							the system perform OCR and PDF parsing, split the documents into result groups, and then try 
							to match them against existing invoices for a match.
							A single ingestion could result in multiple entires in the Result Triage. 
							`}
							url={'/apAutomation/apIngestions'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'AP Result Triage'}
							icon={RobotIcon}
							description={`This is the results of our AP ingestion and shows the results of the
							FMP's AP processing and the attempting match of a invoice. A user can then
							determine if the information is correct, update it, and push it to a vendor bill.
						 `}
							url={'/apAutomation/apIngestionResults'}
						/>
					</Grid>
				</Grid>
			</>
		);
	}
}

ApAutomationDashboard.propTypes = {
	classes: PropTypes.object.isRequired,
	searchOpisFtpRecords: PropTypes.func.isRequired,
	opisFtpRecords: PropTypes.array,

	searchDataRecords: PropTypes.func.isRequired,
	dataRecords: PropTypes.array,
	addDataRecord: PropTypes.func.isRequired,

	searchNotifierLogs: PropTypes.func.isRequired,
	notifierLogs: PropTypes.array,

	searchStationHistory: PropTypes.func.isRequired,
	stationHistory: PropTypes.array,

	userMap: PropTypes.object,
	authUser: PropTypes.object,

	isExternalLogistics: PropTypes.bool,
};

export default _.flow([withStyles(styles), AuthUserContainer, DashboardContainer])(
	ApAutomationDashboard
);
